import { render } from "./PadelInput.vue?vue&type=template&id=e7ffab1c&scoped=true"
import script from "./PadelInput.vue?vue&type=script&lang=ts"
export * from "./PadelInput.vue?vue&type=script&lang=ts"

import "./PadelInput.vue?vue&type=style&index=0&id=e7ffab1c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-e7ffab1c"

export default script